import { Component, Input } from '@angular/core';

@Component({
  selector: 'calsoft-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  
  @Input() tabledata: any[] = [{  },];

  constructor() { }

  ngOnInit(): void {    
    console.log(this.tabledata);
    
    this.tableHeaders=Object.keys(this.tabledata[0]);
  }


  tableHeaders: string[] = Object.keys(this.tabledata[0]);

}